import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  exportTransactions: 'Export transactions',
  transactionsWarning:
    'Exporting transactions has a maximum range of 12 months.',
})
